<template>
  <div>
    <PaginationController
      ref="historyTable"
      v-model="unscannedItems"
      getDataActionName="getUnScannedItems"
      :historyLimit="limit"
      :haveStartDate="isSearchWarehouseSite"
      :haveNoEndDate="!isSearchWarehouseSite"
      :actionPredicates="predicates"
    >
      <template v-slot:dataTable>
        <v-data-table
          :headers="headers"
          :items="unscannedItems"
          item-key="_key"
          hide-actions
        >
          <template v-slot:items="props">
            <td class="text-xs-left" >{{ props.item.date }}</td>
            <td class="text-xs-left" >{{ toDateYYYYMMDDHHmm(props.item.lastModifiedTime) }}</td>
            <td class="text-xs-left">{{ props.item.trackings.length }}</td>
            <td class="text-xs-left">{{ props.item.siteName }}</td>
            <td class="text-xs-center">
              <v-layout justify-center>
                <v-btn color="primary" flat @click.stop="showDetailDialog(props.item)">{{ $t('details') }}</v-btn>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </template>
      <template v-slot:beforeMenu>
        <v-layout>
          <v-flex xs3 mr-3>
            <v-autocomplete
              :items="searchTypes"
              item-value="value"
              item-text="name"
              v-model="searchType"
              :label="$t('filterBy')"></v-autocomplete>
          </v-flex>
          <v-flex xs3 mr-3>
            <v-autocomplete
              v-if="isSearchWarehouseSite"
              :items="warehousesSites"
              item-value="key"
              item-text="siteName"
              v-model="warehouseSite"
              :label="$t('warehouseSite')"></v-autocomplete>
            <v-text-field
              v-else
              v-model="tracking"
              :label="$t('searchByTracking')"/>
          </v-flex>
        </v-layout>
      </template>
    </PaginationController>

    <UnScannedDetailPopup
      v-model="dialog.show"
      v-if="dialog.show"
      :item="dialog.data"
    />
  </div>
</template>

<script>

import {timeTools} from '@/utils/tools'
import PaginationController from './PaginationController'
import UnScannedDetailPopup from './UnScannedDetailPopup'

export default {
  name: 'unScannedTab',
  components: {
    PaginationController,
    UnScannedDetailPopup
  },
  mixins: [
    timeTools
  ],
  data () {
    return {
      unscannedItems: [],
      limit: 25,
      searchType: 'warehouseSite',
      warehouseSite: '',
      tracking: '',
      dialog: {
        show: false,
        data: {}
      }
    }
  },
  computed: {
    predicates () {
      const predicates = []
      if (this.isSearchWarehouseSite) {
        this.warehouseSite && predicates.push({
          field: 'warehouseSite',
          compare: '==',
          value: this.warehouseSite
        })
      } else if (this.tracking) {
        predicates.push({
          field: 'trackings',
          compare: 'array-contains',
          value: this.tracking.trim()
        })
      }
      return predicates
    },    
    headers () {
      return [
        { text: this.$t('date'), value: 'date', align: 'left', sortable: false },
        { text: this.$t('lastModifiedTime'), value: 'lastModifiedTime', align: 'left', sortable: false },
        { text: this.$t('quantity'), value: '', align: 'left', sortable: false },
        { text: this.$t('site'), value: 'siteName', align: 'left', sortable: false },
        { text: this.$t('action'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    },
    warehousesSites () {
      return [
        { key: '', siteName: this.$t('all') },
        ...this.$store.getters.warehousesSites
      ]
    },
    searchTypes () {
      return [
        { name: this.$t('warehouseSite'), value: 'warehouseSite' }, 
        { name: this.$t('tracking'), value: 'tracking' }
      ]
    },
    isSearchWarehouseSite () {
      return this.searchType === 'warehouseSite'
    }
  },
  methods: {
    showDetailDialog (item) {
      Object.assign(this.dialog,
        { 
          show: true,
          data: { ...item }
        }
      )
    }
  }
}
</script>

<style>
.non-uploaded-tracking {
  border: 1px solid;
  padding: 0 3px;
  border-color: deepskyblue;
}
</style>



// WEBPACK FOOTER //
// src/components/UnScannedTab.vue